import { RevButton, RevDialog } from "@revmatics/catalyst";
import { ContactUsWrapperPage } from "../../help/contactUs/ContactUsWrapperPage";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const CONTACT_FORM_ID = "onboarding-contact-form";

export const HelpDialog = ({ isOpen, onClose }: Props) => {
  const handleFormSubmit = () => {
    const form = document.getElementById(CONTACT_FORM_ID) as HTMLFormElement;
    if (form) {
      form.requestSubmit();
    }
  };

  return (
    <RevDialog
      isOpen={isOpen}
      setIsOpen={onClose}
      title="Contact Us"
      size="s"
      mobileSize="xs"
      btnList={[
        <RevButton
          key="help-dialog-cancel"
          text="Cancel"
          variant="secondary"
          handleClick={onClose}
        />,
        <RevButton
          key="help-dialog-send"
          text="Send Message"
          variant="primary"
          handleClick={handleFormSubmit}
        />,
      ]}
    >
      <ContactUsWrapperPage
        useCardWrapper={false}
        showTitle={false}
        showSubmitButton={false}
        formId={CONTACT_FORM_ID}
        onSuccess={onClose}
      />
    </RevDialog>
  );
};
